import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RedirectCommand, ResolveFn, Router, RouterStateSnapshot } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { JobsService } from '../../core/services/jobs.service';
import { LanguageService } from '../../core/services/language.service';
import { JobVacancy } from '../../shared/model/jobs.model';

export const jobDetailResolver: ResolveFn<JobVacancy | null> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const jobsService = inject(JobsService);
  const router = inject(Router);
  const languageService = inject(LanguageService);

  const slug = route.paramMap.get('job_vacancy_slug');

  if (!slug) {
    return new RedirectCommand(router.parseUrl(`/${ languageService.getLang() }/not-found`));
  }

  return jobsService.getJobVacancyBySlug(slug).pipe(
    map(response => {
      const jobDetail: JobVacancy | undefined = response?.data || undefined;

      if (jobDetail?.job_vacancy_slug && jobDetail.job_vacancy_slug !== slug) {
        const redirectUrl = router.parseUrl(`/${ languageService.getLang() }/careers/${ jobDetail.job_vacancy_slug }`);
        return new RedirectCommand(redirectUrl, { replaceUrl: true });
      }

      return jobDetail || null;
    }),
    catchError(() => {
      return of(new RedirectCommand(router.parseUrl(`/${ languageService.getLang() }/not-found`)));
    }),
  );
};
